<template>
  <v-dialog v-model="dialog" persistent max-width="290">
    <template v-slot:activator="{ on }">
      <template v-if="button">
        <v-btn :disabled="disabled" small depressed @click.stop="dialog = true" :color="color">{{text}}</v-btn>
      </template>
      <template v-else-if="list_item">
        <v-list-item @click.stop="dialog = true">
          <v-list-item-icon>
             <v-icon :disabled="disabled" :color="color" :small="small" >delete</v-icon>
          </v-list-item-icon>
          <v-list-item-content>{{$t('delete')}}</v-list-item-content>
        </v-list-item>
      </template>
      <template v-else>
        <v-icon :disabled="disabled" :color="color" v-if="icon" :small="small" @click.stop="dialog = true">delete</v-icon>
        <v-btn :disabled="disabled" :color="color" v-else icon :small="small" v-on="on">
          <v-icon :disabled="disabled" :color="color" :small="small">delete</v-icon>
        </v-btn>
      </template>
    </template>
    <v-card>
      <v-card-title class="headline">{{$t('warning')}}</v-card-title>
      <v-card-text>{{$t('areYouSure')}}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
         
        <v-btn color="primary" text autofocus @click="dialog = false">{{$t('cancel')}}</v-btn>
        <v-btn color="red" text @click="remove(id,fk)">{{$t('delete')}}</v-btn>
       
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
export default {
  props: {
    object: String,
    id: String,
    icon: Boolean,
    button: Boolean,
    fk: String,
    small: Boolean,
    text: String,
    list_item: Boolean,
    color: {
      type: String,
      default: "error"
    },
    disabled: Boolean
  },
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    remove(id, fk) {
      switch (this.object) {
        case "project":
          this.$http
            .deleteProject(id)
            .then(res => {
              this.$noty.success('<i class="fas fa-check"></i>');
              this.$emit("delete", id);
              this.dialog = false;
            })
            .catch(err => {
              this.$noty.error(this.$t("error"));
              console.log(err);
            });
          break;
        case "buildingComponent":
          this.$http
            .deleteBuildingComponents(id)
            .then(res => {
              this.$noty.success('<i class="fas fa-check"></i>');
              this.$emit("delete", id);
              this.dialog = false;
            })
            .catch(err => {
              this.$noty.error(this.$t("error"));
              console.log(err);
            });
          break;
        case "blueprint":
          this.$http
            .deleteBlueprint(id)
            .then(res => {
              this.$noty.success('<i class="fas fa-check"></i>');
              this.$emit("delete", id);
              this.dialog = false;
            })
            .catch(err => {
              this.$noty.error(this.$t("error"));
              console.log(err);
            });
          break;
        case "marker":
          // code block
          this.$http
            .deleteMarker(id)
            .then(rs => {
              this.$noty.success('<i class="fas fa-check"></i>');
              this.$emit("delete", id);
              this.dialog = false;
            })
            .catch(err => {
              this.$noty.error(this.$t("error"));
              console.log(err);
            });
          break;
        case "attachment":
          // code block
          this.$http
            .deleteAttachment(id)
            .then(res => {
              this.$noty.success('<i class="fas fa-check"></i>');
              this.$emit("delete", id);
              this.dialog = false;
            })
            .catch(err => {
              this.$noty.error(this.$t("error"));
              console.log(err);
            });
          break;
        case "attribute":
          // code block
          this.$http
            .deleteAttribute(id)
            .then(res => {
              this.$noty.success('<i class="fas fa-check"></i>');
              this.$emit("deleteAttribute", id);
              this.dialog = false;
            })
            .catch(err => {
              this.$noty.error(this.$t("error"));
              console.log(err);
            });
          break;
        case "attributeValue":
          // code block
          this.$http
            .deleteValues(id)
            .then(res => {
              this.$noty.success('<i class="fas fa-check"></i>');
              this.$emit("deleteValue", id);
              this.dialog = false;
            })
            .catch(err => {
              this.$noty.error(this.$t("error"));
              console.log(err);
            });
          break;
        case "solution":
          // code block
          break;
        case "solutionXproduct":
          if (fk !== "") {
            this.$http
              .deleteSolutionXproduct(id, fk)
              .then(res => {
                this.$noty.success('<i class="fas fa-check"></i>');
                this.$emit("deleteSolutionXproduct", fk);
                this.dialog = false;
              })
              .catch(err => {
                this.$noty.error(this.$t("error"));
                console.log(err);
              });
          }

          break;
        case "installer":
          // code block
          break;
        case "productAttachment":
          this.$http
            .deleteProductAttachment(id)
            .then(res => {
              this.$noty.success('<i class="fas fa-check"></i>');
              this.$emit("delete", id);
              this.dialog = false;
            })
            .catch(err => {
              this.$noty.error(this.$t("error"));
              console.log(err);
            });
          break;
        case "report":
          this.$http
            .deleteReport(id)
            .then(res => {
              this.$noty.success('<i class="fas fa-check"></i>');
              this.$emit("delete", id);
              this.dialog = false;
            })
            .catch(err => {
              this.$noty.error(this.$t("error"));
              console.log(err);
            });
        default:
          this.$emit("delete");
          this.dialog = false;
      }
      this.dialog = false;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/AreYouSure.vue